import React from 'react';
import CentralizedAdmissionCards from './commonComponents/CentralizedAdmisssionCards';

const CentralizedAdmission = () => {
    return (
        <CentralizedAdmissionCards />
    );
}

export default CentralizedAdmission;